// Validation helpers for Pension Calculators

export function calculateAgeFromDob(dateOfBirth) {
  if (!dateOfBirth) return 0;
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function validateRetireWithTab({ dateOfBirth, retirementAge, targetAmount }) {
  const errors = [];
  const fieldErrors = {};
  const hasDob = Boolean(dateOfBirth);
  const retirementAgeNum = Number(retirementAge);
  const currentAge = calculateAgeFromDob(dateOfBirth);

  if (!hasDob) {
    errors.push('Date of birth is required.');
    fieldErrors.dateOfBirth = 'Date of birth is required.';
  } else if (new Date(dateOfBirth) > new Date()) {
    errors.push('Date of birth cannot be in the future.');
    fieldErrors.dateOfBirth = 'Date of birth cannot be in the future.';
  }

  if (!(retirementAgeNum > currentAge)) {
    errors.push('Retirement age must be greater than your current age.');
    fieldErrors.retirementAge = 'Retirement age must be greater than your current age.';
  }
  if (!(retirementAgeNum >= 19)) {
    errors.push('Retirement age must be at least 19.');
    fieldErrors.retirementAge = fieldErrors.retirementAge || 'Retirement age must be at least 19.';
  }
 
  if (!(Number(targetAmount) > 0)) {
    errors.push('Target amount must be greater than 0.');
    fieldErrors.targetAmount = 'Target amount must be greater than 0.';
  }

  const savingDurationYears = Math.max(0, retirementAgeNum - currentAge);

  return { errors, fieldErrors, savingDurationYears };
}

export function validateSaveMonthlyTab({ dateOfBirth, retirementAge, monthlySavings, initialAmount, annualIncreaseRate }) {
  const errors = [];
  const fieldErrors = {};
  const hasDob = Boolean(dateOfBirth);
  const retirementAgeNum = Number(retirementAge);
  const currentAge = calculateAgeFromDob(dateOfBirth);

  if (!hasDob) {
    errors.push('Date of birth is required.');
    fieldErrors.dateOfBirth = 'Date of birth is required.';
  } else if (new Date(dateOfBirth) > new Date()) {
    errors.push('Date of birth cannot be in the future.');
    fieldErrors.dateOfBirth = 'Date of birth cannot be in the future.';
  }

  if (!(retirementAgeNum > currentAge)) {
    errors.push('Retirement age must be greater than your current age.');
    fieldErrors.retirementAge = 'Retirement age must be greater than your current age.';
  }
  if (!(retirementAgeNum >= 19)) {
    errors.push('Retirement age must be at least 19.');
    fieldErrors.retirementAge = fieldErrors.retirementAge || 'Retirement age must be at least 19.';
  }
  if (!(Number(monthlySavings) >= 1000)) {
    errors.push('Monthly contribution must be at least 1000 KES.');
    fieldErrors.monthlySavings = 'Monthly contribution must be at least 1000 KES.';
  }
  if (!(Number(initialAmount) >= 0)) {
    errors.push('Initial amount must be 0 or greater.');
    fieldErrors.initialAmount = 'Initial amount must be 0 or greater.';
  }
  if (!(Number(annualIncreaseRate) >= 0)) {
    errors.push('Annual increase rate must be 0 or greater.');
    fieldErrors.annualIncreaseRate = 'Annual increase rate must be 0 or greater.';
  }
  

  const savingDurationYears = Math.max(0, retirementAgeNum - currentAge);

  return { errors, fieldErrors, savingDurationYears };
}


